import { userService } from '../_services';
import router from '../routes/router';

var user;
try{
    user = JSON.parse(localStorage.getItem('user'));
}catch{}

const initialState = user
    ? { status: { loggedIn: true }, user }
    : { status: {}, user: null };

export const authentication = {
    namespaced: true,
    state: initialState,
    actions: {
        login({ dispatch, commit }, { email, password, clientId }) {
            commit('loginRequest', { email });

            return userService.login(email, password, clientId)
                .then(
                    user => {
                        dispatch('resetSessionState');

                        commit('loginSuccess', user);
                        dispatch('users/getCurrentUser', user.id, { root: true })
                        .then(user => {
                            router.push('/dashboard')
                          })
                    },
                    error => {
                        commit('loginFailure', error);
                        dispatch('alert/error', error, { root: true });
                    }
                );
        },
        async logout({ dispatch, commit }) {
            userService.logout();
            commit('logout');
            await dispatch('resetSessionState');
            router.replace('/login');
        },
        setToken({ dispatch, commit }, resp){
            commit('setTokenRequest');

            console.log('module set token');
            return userService.setToken(resp)
            .then(
                user => {
                    console.log('back from service');
                    dispatch('resetSessionState');
                    commit('loginSuccess', user);
                    console.log('getting current user');
                    dispatch('users/getCurrentUser', user.id, { root: true })
                    .then(user => {
                        console.log('heading to dashboard');
                        router.push('/dashboard')
                        })
                },
                error => {
                    commit('loginFailure', error);
                    dispatch('alert/error', error, { root: true });
                }
            );
        },
        register({ dispatch, commit }, user) {
            commit('registerRequest');
            return userService.register(user)
                .then(
                    user => {
                        commit('registerSuccess', user);
                        router.push('/login');
                    },
                    error => {
                        commit('registerFailure', error);
                        dispatch('alert/error', error, { root: true });
                        return Promise.reject(error);
                        reject();
                    }
                )
                .catch(error => {
                    return error;
                    //Promise.reject(error);
                    alert('catching error')
                    return "An error occurred"
                });
        },
        forgotPassword({ dispatch, commit }, params) {
            commit('forgotPasswordRequest');
            userService.forgotPassword(params)
                .then(
                    user => commit('forgotPasswordRequestSuccess', user),
                    error => commit('forgotPasswordRequestFailure', error)
                )
        },
        resetPassword({ dispatch, commit }, params) {
            commit('resetPasswordRequest');
            userService.resetPassword(params)
                .then(
                    user => commit('resetPasswordRequestSuccess', user),
                    error => commit('resetPasswordRequestFailure', error)
                )
        },
        resetSessionState({ dispatch }) {
            dispatch('brands/resetState', {}, {root:true})
            dispatch('comments/resetState', {}, {root:true})
            dispatch('collections/resetState', {}, {root:true})
            dispatch('favorites/resetState', {}, {root:true})
            dispatch('ingredients/resetState', {}, {root:true})
            dispatch('instructions/resetState', {}, {root:true})
            dispatch('notifications/resetState', {}, {root:true})
            dispatch('operators/resetState', {}, {root:true})
            dispatch('products/resetState', {}, {root:true})
            dispatch('recipes/resetState', {}, {root:true})
            dispatch('reportings/resetState', {}, {root:true})
            //dispatch('settings/resetState', {}, {root:true})
            dispatch('socials/resetState', {}, {root:true})
            dispatch('tags/resetState', {}, {root:true})
            dispatch('todos/resetState', {}, {root:true})
            dispatch('units/resetState', {}, {root:true})
            dispatch('users/resetState', {}, {root:true})
        },
        refreshUserData({ commit }, params) {
            commit('refreshUserDataRequest', params);
        },
    },
    mutations: {
        loginRequest(state, user) {
            state.status = { loggingIn: true };
            state.user = user;
        },
        loginSuccess(state, user) {
            state.status = { };
            state.user = user;
        },
        loginFailure(state) {
            state.status = { error: true };
            state.user = null;
        },
        setTokenRequest(state, user) {
            state.status = { loggingIn: true };
            state.user = user;
        },
        setTokenSuccess(state, user) {
            state.status = { };
            state.user = user;
        },
        setTokenFailure(state) {
            state.status = { error: true };
            state.user = null;
        },
        registerRequest(state) {
            state.status = { registering: true };
        },
        registerSuccess(state, user) {
            state.status = { };
            state.user = user;
        },
        registerFailure(state) {
            state.status = { error: true };
            state.user = null;
        },
        forgotPasswordRequest(state) {
            state.status = { submitting: true };
        },
        forgotPasswordRequestSuccess(state, user) {
            state.status = { };
        },
        forgotPasswordRequestFailure(state) {
            state.status = { error: true };
        },
        resetPasswordRequest(state) {
            state.status = { submitting: true };
        },
        resetPasswordRequestSuccess(state, user) {
            state.status = { };
            router.push('/dashboard');
        },
        resetPasswordRequestFailure(state) {
            state.status = { error: true };
        },        
        logout(state) {
            state.status = {};
            state.user = null;
        },
        refreshUserDataRequest(state, params) {
            state.user.user.firstName = params.firstName;
            state.user.user.lastName = params.lastName;
            state.user.user.email = params.email;
            state.user.user.securityLevel = params.securityLevel;
            state.user.user.image = params.image;
        }
    }
}